import { render, staticRenderFns } from "./bafylc.vue?vue&type=template&id=bb494f32&scoped=true"
import script from "./bafylc.vue?vue&type=script&lang=js"
export * from "./bafylc.vue?vue&type=script&lang=js"
import style0 from "./bafylc.vue?vue&type=style&index=0&id=bb494f32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb494f32",
  null
  
)

export default component.exports